/**
 * Check if a given path is an onboarding route
 */
export function isOnboardingRoute(path: string): boolean {
  return path.startsWith('/onboarding');
}
